module.exports = "/images/body-left.svg?5e1f5d692baf43b62e17d4b3bdda0a7b";